export const Theme = {
  colors: {
    background: "#eee",
    light: "#eee",
    lightHover: "#ccc",
    lightActive: "#aaa",
    lightSecondary: "#ddd",
    lightBorder: "#ccc",
    dark: "#333",
    darkHover: "#222",
    darkActive: "#111",
    blue: "#143E72",
    primary: "#1ba148",
    primaryHover: "#0a9037",
    primaryActive: "#098026",
    secondary: "ee1713",
    secondaryHover: "ee1713",
    secondaryActive: "ee1713",
    red: "#b3211e",
    redHover: "#a2100d",
    redActive: "#91000c",
  },
};

export default Theme;
